module.exports = __webpack_public_path__ + "media/images/application/template/product-selector/wind-map-one-8ab4b0911645bde2528aa42ab9302e76.jpg";